import { SyndicateRole, OrderCategory } from './deal.types';

export const ROLES_PRIORITY: SyndicateRole[] = [
  SyndicateRole.seniorManager,
  SyndicateRole.coSenior,
  SyndicateRole.coManager,
  SyndicateRole.sellingGroup,
  SyndicateRole.member,
  SyndicateRole.nonManager
];

export interface OrderType {
  code: string;
  id: number;
  //noinspection JSUnusedGlobalSymbols
  priorityInd: boolean; // renamed from isPriority to priorityInd
  name: string;
}

export interface OrderSyndicateMember {
  id: number;
  name: string;
  role: SyndicateRole;
}

export interface MoneyType {
  code: string;
  name: string;
}

export interface AccountType {
  code: string;
  name: string;
}

export interface Order {
  id: number;
  seriesId: string;
  maturityId: string;
  firmId: number;
  brokerDealerFirmId: number;
  accountName: string;
  orderNumber: number;
  parentWarehouseId: number;
  warehouseId: number;
  repName?: string;
  repNumber?: number;
  retailInd: boolean;
  amount: number;
  comments?: string;
  lastModifiedDate: Date;
  accountType: AccountType;
  moneyType?: MoneyType;
  manager?: string;
  orderType: OrderType;
  syndicateDepartment?: OrderSyndicateMember;
  category: OrderCategory;
}
